import React from 'react';

const SuccessfulSubmission = () => (
  <>
    <h5 className="whitelistRequestForm-success">
      Your claims dispute has been successfully submitted!
    </h5>

    <p className="whitelistRequestForm-message">
      Information regarding your claim has been forwarded to the claimant listed
      on your copyright notice for removal. The time it takes for claims to be
      removed depends on the claimant, but most claims are generally removed
      between 24 hours to 5 business days. We're happy to follow up with you if
      we receive information that the claim removal is taking longer than
      expected. Please let us know if a claim is not released after 5 business
      days.
    </p>

    <p className="whitelistRequestForm-message">
      Thanks for contacting Storyblocks!
    </p>
  </>
);

export default SuccessfulSubmission;
